import _regenerator from "@babel/runtime/helpers/esm/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.all-settled.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { mapActions, mapGetters } from "vuex";
export default {
  computed: _objectSpread(_objectSpread({}, mapGetters("auth", ["empresa", "identificador", "cliente"])), mapGetters("notification", {
    dialog: "dialogPush"
  })),
  methods: _objectSpread(_objectSpread({}, mapActions("notification", ["showDialogPush", "cadastrarToken", "cadastrarWhatsapp"])), {}, {
    aceitarNotificacoes: function aceitarNotificacoes() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var identificador, _this$cliente, tem_push, tem_whatsapp;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              identificador = _this.$route.query.identificador || _this.identificador;
              _this$cliente = _this.cliente, tem_push = _this$cliente.tem_push, tem_whatsapp = _this$cliente.tem_whatsapp;
              _context.n = 1;
              return Promise.allSettled([_this.cadastrarToken(identificador, tem_push)

              // Beatriz irá verificiar viabilidade com ana
              // this.cadastrarWhatsapp([{ numero: "", identificador }, tem_whatsapp])
              ]);
            case 1:
              _this.showDialogPush(false);
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  })
};